import React from 'react';
import CabCrudPage from './CabCrudPage';
import useCabLookups from './useCabLookups';

const AdminCabsPricingRules = () => {
  const { vehicleCategories, seatConfigs, locations, routes } = useCabLookups();

  return (
    <CabCrudPage
      title="Pricing Rules"
      description="Configure cab fare rules for routes, categories, and time windows."
      resource="pricing-rules"
      defaultItem={{
        name: '',
        tripType: 'ONEWAY',
        vehicleCategoryId: '',
        seatConfigId: '',
        routeId: '',
        originLocationId: '',
        destinationLocationId: '',
        baseFare: 0,
        perKmRate: 0,
        perHourRate: '',
        minFare: '',
        minKmPerDay: '',
        driverAllowancePerDay: '',
        nightChargePct: '',
        gstPct: '',
        tollIncluded: false,
        currency: 'INR',
        effectiveFrom: '',
        effectiveTo: '',
        priority: 0,
        isActive: true,
      }}
      columns={[
        { key: 'name', label: 'Rule' },
        { key: 'tripType', label: 'Trip' },
        { key: 'baseFare', label: 'Base' },
        { key: 'perKmRate', label: 'Per km' },
        {
          key: 'vehicleCategory',
          label: 'Category',
          render: (row) => row.vehicleCategory?.name || '�',
        },
      ]}
      fields={[
        { name: 'name', label: 'Rule name', required: true },
        {
          name: 'tripType',
          label: 'Trip type',
          type: 'select',
          required: true,
          options: [
            { value: 'ONEWAY', label: 'One-way' },
            { value: 'ROUNDTRIP', label: 'Round trip' },
          ],
        },
        {
          name: 'vehicleCategoryId',
          label: 'Vehicle category',
          type: 'select',
          required: true,
          options: vehicleCategories.map((c) => ({ value: c.id, label: c.name })),
        },
        {
          name: 'seatConfigId',
          label: 'Seat configuration',
          type: 'select',
          options: seatConfigs.map((c) => ({ value: c.id, label: c.name })),
        },
        {
          name: 'routeId',
          label: 'Route',
          type: 'select',
          options: routes.map((r) => ({ value: r.id, label: `${r.fromLocation?.name} ? ${r.toLocation?.name}` })),
        },
        {
          name: 'originLocationId',
          label: 'Origin location',
          type: 'select',
          options: locations.map((l) => ({ value: l.id, label: l.name })),
        },
        {
          name: 'destinationLocationId',
          label: 'Destination location',
          type: 'select',
          options: locations.map((l) => ({ value: l.id, label: l.name })),
        },
        { name: 'baseFare', label: 'Base fare', type: 'number', required: true },
        { name: 'perKmRate', label: 'Per km rate', type: 'number', required: true },
        { name: 'perHourRate', label: 'Per hour rate', type: 'number' },
        { name: 'minFare', label: 'Minimum fare', type: 'number' },
        { name: 'minKmPerDay', label: 'Min km/day', type: 'number' },
        { name: 'driverAllowancePerDay', label: 'Driver allowance/day', type: 'number' },
        { name: 'nightChargePct', label: 'Night charge (%)', type: 'number' },
        { name: 'gstPct', label: 'GST (%)', type: 'number' },
        { name: 'currency', label: 'Currency' },
        { name: 'effectiveFrom', label: 'Effective from', type: 'datetime-local', required: true },
        { name: 'effectiveTo', label: 'Effective to', type: 'datetime-local' },
        { name: 'priority', label: 'Priority', type: 'number' },
        { name: 'tollIncluded', label: 'Toll included', type: 'checkbox', col: 'col-md-6' },
        { name: 'isActive', label: 'Active', type: 'checkbox', col: 'col-md-6' },
      ]}
      transformPayload={(payload) => ({
        ...payload,
        perHourRate: payload.perHourRate === '' ? null : Number(payload.perHourRate),
        minFare: payload.minFare === '' ? null : Number(payload.minFare),
        minKmPerDay: payload.minKmPerDay === '' ? null : Number(payload.minKmPerDay),
        driverAllowancePerDay: payload.driverAllowancePerDay === '' ? null : Number(payload.driverAllowancePerDay),
        nightChargePct: payload.nightChargePct === '' ? null : Number(payload.nightChargePct),
        gstPct: payload.gstPct === '' ? null : Number(payload.gstPct),
        routeId: payload.routeId || null,
        seatConfigId: payload.seatConfigId || null,
        originLocationId: payload.originLocationId || null,
        destinationLocationId: payload.destinationLocationId || null,
        effectiveTo: payload.effectiveTo || null,
      })}
    />
  );
};

export default AdminCabsPricingRules;
